<template>
  <div style="height: 120px; width: 100%">
    <dv-border-box-12 :title="config.Title">
      <div class="flex-column center st between" style="height: 100%">
        <div class="flex-row number center fnumber"><dv-digital-flop :config="val" style="width: 100px; height: 50px" /></div>
        <div class="flex-row center active">{{ config.Title }}</div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    config: Object
  },
  computed: {
    val() {
      return {
        number: [this.value],
        style: {
          fill: '#4d99fc',
          fontWeight: 'bold'
        }
      }
    }
  },
  methods: {}
}
</script>

<style scoped>
.active {
  color: #4d99fc;
}
.box-panel {
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.c-gray {
  color: #909399;
}

.c-gray-bold {
  color: #49494b;
  font-weight: bold;
}

.fnumber {
  font-size: 30px;
}

.table-cell {
  display: table-cell;
  vertical-align: bottom;
}

.img-box {
  background: #f3f3f1;
  border-radius: 10px;
  width: 60px;
  height: 60px;
  text-align: center;
  align-items: center;
  display: flex;
  margin-right: 20px;
}
</style>